import React from "react"
import { routePaths } from "../.."
import { SuperAILabelers } from "../../../Components/Views/Dashboard/Sections/AppDetail/Collaborators/SuperAILabelers"
import {
    decodeSuperAILabelerParams,
    SuperAILabelerModel
} from "../../../Models/Client/SuperAILabelerModel"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"

export function AppSuperAILabelersRoute({
    match,
    location
}: AppDetailRouteComponentProps) {
    const filterAndSort = useDecodeFilterAndSort<SuperAILabelerModel>(
        location.search,
        { sortBy: "email", desc: false },
        routePaths.appSuperAILabelers(
            match.params.orgUsername,
            match.params.appID
        )
    )

    const params = decodeSuperAILabelerParams(filterAndSort)

    return (
        <AppAuthCheck {...match.params} scope="crowd:view">
            <SuperAILabelers
                {...match.params}
                params={params}
                filterAndSort={filterAndSort}
            />
        </AppAuthCheck>
    )
}
